import { render, staticRenderFns } from "./RemoveTagModal.vue?vue&type=template&id=f7ca1b54&"
import script from "./RemoveTagModal.vue?vue&type=script&lang=js&"
export * from "./RemoveTagModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveTagModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports